export enum Unit {
  CURRENCY = 'currency',
  PERCENTAGE = 'percentage',
}
